import {executeCall} from './CallService';


export const docProjectList = async (projectId) => {
    const action = "project.doc";
    const data = {
        query: "listByProjectId",
        project_id: projectId
    };
    return await executeCall(action, data);
}

export const docProjectListOnly = async (projectId) => {
    const action = "project.doc";
    const data = {
        query: "listByProjectIdOnly",
        project_id: projectId
    };
    return await executeCall(action, data);
}

export const docTaskList = async (taskId) => {
    const action = "project.doc";
    const data = {
        query: "listByProjectTaskId",
        project_task_id: taskId
    };
    return await executeCall(action, data);
}

/**
 * Upload a new document. The values param must have the following fields:
 * {
 *      project_id: project_id,
 *      project_task_id: project_task_id,           // optional, may be null
 *      label: label,
 *      file_name: file_name,
 *      mime_type: mime_type,
 *      content: b64content
 * }
 */
export const docCreate = async (values) => {
    const action = "project.doc";
    const data = {
        query: "create",
        values: values
    };
    return await executeCall(action, data);
}

export const docRead = async (docId) => {
    const action = "project.doc";
    const data = {
        query: "read",
        id: docId
    };
    return await executeCall(action, data);
}

export const docDelete = async (docId) => {
    const action = "project.doc";
    const data = {
        query: "delete",
        id: docId
    };
    return await executeCall(action, data);
}

